import React from "react"

const { Container , Row , Col  , Card , CardBody

} = require("reactstrap")
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { useQuery } from "react-query"
import {  getReportMessages} from "helpers/fakebackend_helper"


const ReportedMessageList = () => {

 
    const { data, isLoading } = useQuery('waitlist', getReportMessages, {
        // staleTime: 120000,
          refetchOnWindowFocus: false,
        });
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags></MetaTags>
                <Container fluid style={{ minHeight: "100vh" }}>
                    <Breadcrumbs title="Reported Messages" breadcrumbItem="Reported Message" />
                    <Row>
                        <Col >
                            <Card>
                                <CardBody>
                                    {isLoading ? (
                                        <div>Loading...</div>
                                    ) : !data ? (
                                        <div>No waitlist available.</div>
                                    ) : (
                                        <table className="table   ">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">Sender</th>
                                                    <th scope="col">Receiver</th>
                                                    <th scope="col">Message</th>
                                                    <th scope="col">Reported At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map(report => (
                                                    <tr key={report.id}>
                                                        <td>{report.id}</td>
                                                        <td>{report.sender.name}</td>
                                                        <td>{report.receiver.name}</td>
                                                        <td style={{ whiteSpace: 'normal', width: '350px' }}>{report.message.message}</td>
                                                        <td>{new Date(report.created_at).toLocaleString()}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }

export default ReportedMessageList;

